import React, { createContext, useState, useContext } from 'react';

const LanguageContext = createContext(null);

const translations = {
  da: {
    // Login
    emailAddress: 'E-mailadresse',
    password: 'Adgangskode',
    signIn: 'Log ind',
    signingIn: 'Logger ind...',
    areYouNewCustomer: 'Er du ny kunde?',
    toAccessFastTrack: 'For at få adgang til Ole Larsen FastTrack skal du have en konto, ring til os på',
    needHelp: 'Brug for hjælp?',
    call: 'Ring',
    welcome: 'Velkommen',

    // Header & Navigation
    overview: 'Overblik',
    orders: 'Ordrer',
    administration: 'Administration',
    searchPlaceholder: 'Søg efter ordre, kunde eller faktura ref.',
    bookOrder: 'Book ordre',
    logOut: 'Log ud',

    // Dashboard
    activeOrders: 'Aktive ordrer (2 dage)',
    pastOrders: 'Tidligere ordrer (2-7 dage)',
    seeAllPastOrders: 'Se alle tidligere ordrer',
    loading: 'Indlæser...',
    noActiveOrders: 'Ingen aktive ordrer',
    noPastOrders: 'Ingen tidligere ordrer',
    bookingAccepted: 'Booking accepteret',
    bookingPending: 'Afventer godkendelse',
    bookingApproved: 'Godkendt',
    bookingRejected: 'Afvist',
    noRequirement: 'Ingen krav',

    // Sidebar
    benefitsTitle: 'Fordele med Ole Larsen FastTrack',
    selfService: 'Selvbetjening',
    selfServiceDesc: 'Du kan downloade Excel-filer, printe fragtbreve osv.',
    easyBooking: 'Nem booking',
    easyBookingDesc: '5 klik til en booking',
    customerFocus: 'Kundefokus',
    customerFocusDesc: 'En god oplevelse hver gang',
    development: 'Udvikling',
    developmentDesc: 'Vi stopper aldrig med at tilføje nye funktioner',

    // Order Form
    cancel: 'Annuller',
    template: 'Skabelon',
    orderBooking: 'Ordre booking',
    sender: 'Afsender',
    recipient: 'Modtager',
    pickupDate: 'Afhentningsdato',
    earliestPickup: 'Tidligste afhentning',
    searchAddress: 'Søg adresse',
    pickupNotes: 'Afhentningsnoter',
    deliveryNotes: 'Leveringsnoter',
    invoiceRef: 'Faktura ref.',
    supplierRef: 'Leverandør ref.',
    saveAsTemplate: 'Gem som skabelon',
    send: 'Send',
    sending: 'Sender...',
    selectAddress: 'Vælg adresse...',

    // Orders page
    allOrders: 'Alle ordrer',
    orderDate: 'Dato',
    orderReference: 'Reference',
    orderFrom: 'Fra',
    orderTo: 'Til',
    orderStatus: 'Status',

    // Administration
    addresses: 'Adresser',
    templates: 'Skabeloner',
    settings: 'Indstillinger',
    addNewAddress: 'Tilføj ny adresse',
    name: 'Navn',
    street: 'Gade',
    postalCode: 'Postnummer',
    city: 'By',
    save: 'Gem',
    delete: 'Slet',
    edit: 'Rediger',

    // Administration - extra
    invoices: 'Fakturaer',
    users: 'Brugere',
    invoiceNumber: 'Fakturanr.',
    date: 'Dato',
    dueDate: 'Forfald',
    amount: 'Beløb',
    paid: 'Betalt',
    sent: 'Sendt',
    creditNote: 'Kreditnota',
    noInvoices: 'Ingen fakturaer endnu',
    noUsers: 'Ingen brugere med portaladgang',
    role: 'Rolle',
    lastLogin: 'Sidste login',
    admin: 'Administrator',
    user: 'Bruger',
    viewer: 'Visning',
    never: 'Aldrig',
    addUser: 'Opret bruger',
    editUser: 'Rediger bruger',
    email: 'Email',
    phone: 'Telefon',
    mobile: 'Mobil',
    newPassword: 'Adgangskode',
    passwordHint: 'Udfyld kun ved ny bruger eller ændring',
    userCreated: 'Bruger oprettet',
    userUpdated: 'Bruger opdateret',
    userDeleted: 'Bruger slettet',
    confirmDeleteUser: 'Er du sikker på at du vil slette denne bruger?',
    creating: 'Opretter...',
    saving: 'Gemmer...',

    // New features
    calendar: 'Kalender',
    insights: 'Indsigt',
    shortcuts: 'Genveje',
    widgets: 'Widgets',
    editBooking: 'Rediger booking',
    editNotice: 'Du redigerer en eksisterende booking. Ændringer sendes til godkendelse.',
    saveChanges: 'Gem ændringer',
    comment: 'Kommentar',
    comments: 'Kommentarer',
    writeComment: 'Skriv en kommentar...',
    noComments: 'Ingen kommentarer endnu. Skriv en besked til Ole Larsen Transport.',
    send: 'Send',
    filter: 'Filtrer...',
    clearFilters: 'Ryd filtre',
    exportExcel: 'Eksporter Excel',
    allStatuses: 'Alle',
    goodsDescription: 'Varebeskrivelse',
    quantity: 'Antal',
    unitLabel: 'Enhed',
    temperature: 'Temperatur',
    actions: 'Handlinger',
    edit: 'Rediger',
    palleLabel: 'Pallelabel',
    freightLetter: 'Fragtbrev',
    selected: 'valgt',
    printPalleLabels: 'Print pallelabels',
    printFreightLetters: 'Print fragtbreve',
    import: 'Import',
    today: 'I dag',
    noBookingsThisDay: 'Ingen bookinger denne dag',
    bookingsCount: 'bookinger',
    activeWidget: 'Aktive ordrer',
    pastWidget: 'Tidligere ordrer',
    sidebarWidget: 'Sidebar',
    aiMate: 'Din AI-makker',
    aiThinking: 'Tænker...',
    aiPlaceholder: 'Spørg om dine bookinger...',
    returnEu: 'Retur EU',
    returnHalf: 'Retur ½',
    returnQuarter: 'Retur ¼',
    returnHint: 'Emballagebytte - paller retur fra modtager',
    euPallets: 'EU paller',
    halfPallets: '½ paller',
    quarterPallets: '¼ paller',
    bookingUpdated: 'Booking opdateret og sendt til godkendelse!',
    lockedError: 'Denne booking er låst og kan ikke redigeres',
    date: 'Dato',
    ref: 'Ref',
    from: 'Fra',
    to: 'Til',
    statusCol: 'Status',
    noDataAvailable: 'Ingen data tilgængelig',
    bookings30days: 'Bookinger (30 dage)',
    vsPreviousPeriod: 'vs. forrige periode',
    previousPeriod: 'Forrige periode',
    totalUnits: 'Enheder total',
    last30days: 'Sidste 30 dage',
    topRoutes: 'Top ruter',
    topGoods: 'Top varer',
    weeklyBreakdown: 'Ugentlig fordeling',
    noData: 'Ingen data',
    noRoutes: 'Ingen ruter endnu',
    noGoods: 'Ingen varer endnu',
    lines: 'Linjer',
  },
  en: {
    // Login
    emailAddress: 'Email Address',
    password: 'Password',
    signIn: 'Sign in',
    signingIn: 'Signing in...',
    areYouNewCustomer: 'Are you new customer?',
    toAccessFastTrack: 'To access Ole Larsen FastTrack You need an account, call us at',
    needHelp: 'Need help?',
    call: 'Call',
    welcome: 'Welcome',

    // Header & Navigation
    overview: 'Overview',
    orders: 'Orders',
    administration: 'Administration',
    searchPlaceholder: 'Search for order, customer or invoice ref.',
    bookOrder: 'Book order',
    logOut: 'Log out',

    // Dashboard
    activeOrders: 'Active orders (2 days)',
    pastOrders: 'Past orders (2-7 days)',
    seeAllPastOrders: 'See all past orders',
    loading: 'Loading...',
    noActiveOrders: 'No active orders',
    noPastOrders: 'No past orders',
    bookingAccepted: 'Booking accepted',
    bookingPending: 'Pending approval',
    bookingApproved: 'Approved',
    bookingRejected: 'Rejected',
    noRequirement: 'No requirement',

    // Sidebar
    benefitsTitle: 'Benefits with Ole Larsen FastTrack',
    selfService: 'Self-service',
    selfServiceDesc: 'You can download Excel files, print freight letters etc.',
    easyBooking: 'Easy booking',
    easyBookingDesc: '5 clicks to a booking',
    customerFocus: 'Customer focus',
    customerFocusDesc: 'A good experience every time',
    development: 'Development',
    developmentDesc: 'We never stop adding new features',

    // Order Form
    cancel: 'Cancel',
    template: 'Template',
    orderBooking: 'Order booking',
    sender: 'Sender',
    recipient: 'Recipient',
    pickupDate: 'Pick up date',
    earliestPickup: 'Earliest pickup',
    searchAddress: 'Search address',
    pickupNotes: 'Pickup notes',
    deliveryNotes: 'Delivery notes',
    invoiceRef: 'Invoice ref.',
    supplierRef: 'Supplier ref.',
    saveAsTemplate: 'Save as template',
    send: 'Send',
    sending: 'Sending...',
    selectAddress: 'Select address...',

    // Orders page
    allOrders: 'All orders',
    orderDate: 'Date',
    orderReference: 'Reference',
    orderFrom: 'From',
    orderTo: 'To',
    orderStatus: 'Status',

    // Administration
    addresses: 'Addresses',
    templates: 'Templates',
    settings: 'Settings',
    addNewAddress: 'Add new address',
    name: 'Name',
    street: 'Street',
    postalCode: 'Postal code',
    city: 'City',
    save: 'Save',
    delete: 'Delete',
    edit: 'Edit',

    // Administration - extra
    invoices: 'Invoices',
    users: 'Users',
    invoiceNumber: 'Invoice no.',
    date: 'Date',
    dueDate: 'Due date',
    amount: 'Amount',
    paid: 'Paid',
    sent: 'Sent',
    creditNote: 'Credit note',
    noInvoices: 'No invoices yet',
    noUsers: 'No users with portal access',
    role: 'Role',
    lastLogin: 'Last login',
    admin: 'Administrator',
    user: 'User',
    viewer: 'Viewer',
    never: 'Never',
    addUser: 'Add user',
    editUser: 'Edit user',
    email: 'Email',
    phone: 'Phone',
    mobile: 'Mobile',
    newPassword: 'Password',
    passwordHint: 'Only fill in for new user or password change',
    userCreated: 'User created',
    userUpdated: 'User updated',
    userDeleted: 'User deleted',
    confirmDeleteUser: 'Are you sure you want to delete this user?',
    creating: 'Creating...',
    saving: 'Saving...',

    // New features
    calendar: 'Calendar',
    insights: 'Insights',
    shortcuts: 'Shortcuts',
    widgets: 'Widgets',
    editBooking: 'Edit booking',
    editNotice: 'You are editing an existing booking. Changes will be sent for approval.',
    saveChanges: 'Save changes',
    comment: 'Comment',
    comments: 'Comments',
    writeComment: 'Write a comment...',
    noComments: 'No comments yet. Write a message to Ole Larsen Transport.',
    send: 'Send',
    filter: 'Filter...',
    clearFilters: 'Clear filters',
    exportExcel: 'Export Excel',
    allStatuses: 'All',
    goodsDescription: 'Goods description',
    quantity: 'Quantity',
    unitLabel: 'Unit',
    temperature: 'Temperature',
    actions: 'Actions',
    edit: 'Edit',
    palleLabel: 'Pallet label',
    freightLetter: 'Freight letter',
    selected: 'selected',
    printPalleLabels: 'Print pallet labels',
    printFreightLetters: 'Print freight letters',
    import: 'Import',
    today: 'Today',
    noBookingsThisDay: 'No bookings this day',
    bookingsCount: 'bookings',
    activeWidget: 'Active orders',
    pastWidget: 'Past orders',
    sidebarWidget: 'Sidebar',
    aiMate: 'Your AI buddy',
    aiThinking: 'Thinking...',
    aiPlaceholder: 'Ask about your bookings...',
    returnEu: 'Return EU',
    returnHalf: 'Return ½',
    returnQuarter: 'Return ¼',
    returnHint: 'Pallet exchange - return pallets from recipient',
    euPallets: 'EU pallets',
    halfPallets: '½ pallets',
    quarterPallets: '¼ pallets',
    bookingUpdated: 'Booking updated and sent for approval!',
    lockedError: 'This booking is locked and cannot be edited',
    date: 'Date',
    ref: 'Ref',
    from: 'From',
    to: 'To',
    statusCol: 'Status',
    noDataAvailable: 'No data available',
    bookings30days: 'Bookings (30 days)',
    vsPreviousPeriod: 'vs. previous period',
    previousPeriod: 'Previous period',
    totalUnits: 'Total units',
    last30days: 'Last 30 days',
    topRoutes: 'Top routes',
    topGoods: 'Top goods',
    weeklyBreakdown: 'Weekly breakdown',
    noData: 'No data',
    noRoutes: 'No routes yet',
    noGoods: 'No goods yet',
    lines: 'Lines',
  }
};

export function LanguageProvider({ children }) {
  const [language, setLanguage] = useState('da');

  const t = (key) => {
    return translations[language][key] || key;
  };

  return (
    <LanguageContext.Provider value={{ language, setLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within LanguageProvider');
  }
  return context;
}
